var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgReprintIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Outline / Arrows /  Round Transfer Diagonal"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector (Stroke)",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.17241 3.99065C3.41587 5.40351 2.29175 7.57064 2.29175 10.0003C2.29175 14.2575 5.74289 17.7087 10.0001 17.7087C11.3698 17.7087 12.6561 17.3514 13.7708 16.725L8.85711 11.5633V13.7503C8.85711 14.0955 8.57729 14.3753 8.23211 14.3753C7.88693 14.3753 7.60711 14.0955 7.60711 13.7503V10.0003C7.60711 9.7447 7.76273 9.51486 8.00005 9.41996C8.23737 9.32507 8.50856 9.38423 8.68479 9.56935L14.8211 16.0153C16.5815 14.6026 17.7084 12.4331 17.7084 10.0003C17.7084 5.74313 14.2573 2.29199 10.0001 2.29199C8.62607 2.29199 7.33603 2.65149 6.21888 3.28155L10.9404 8.4009V6.25042C10.9404 5.90524 11.2203 5.62542 11.5654 5.62542C11.9106 5.62542 12.1904 5.90524 12.1904 6.25042V10.0004C12.1904 10.2578 12.0326 10.4889 11.7929 10.5826C11.5532 10.6762 11.2805 10.6134 11.106 10.4241L5.17241 3.99065ZM1.04175 10.0003C1.04175 5.05277 5.05253 1.04199 10.0001 1.04199C14.9476 1.04199 18.9584 5.05277 18.9584 10.0003C18.9584 14.9479 14.9476 18.9587 10.0001 18.9587C5.05253 18.9587 1.04175 14.9479 1.04175 10.0003Z",
    fill: "#1A1B1D"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReprintIcon);
export default __webpack_public_path__ + "static/media/reprintIcon.074a061cc9e3d551c9ac51bff1ccfc4b.svg";
export { ForwardRef as ReactComponent };